import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';

const Dashboard = lazy(() => import('./Dashboard'));
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const ResourcePage = lazy(() => import('./ResourcePage'));
const Versions = lazy(() => import('./Versions'));
const Update = lazy(() => import('./Update'));
const UpdatePath = lazy(() => import('./UpdatePath'));

export function WebTreeRoutes() {
  return (
    <Routes>
      <Route path={Pages.cms.webtree.meta.path}>
        <Route
          index
          element={(<Dashboard />)}
        />
        <Route
          path={Pages.cms.webtree.list.meta.path}
          element={(<List />)}
        />
        <Route
          path={Pages.cms.webtree.create.meta.path}
          element={(<Create />)}
        />
        <Route
          path={Pages.cms.webtree.read.meta.path}
          element={(<ResourcePage />)}
        />
        <Route
          path={Pages.cms.webtree.versions.meta.path}
          element={(<Versions />)}
        />
        <Route
          path={Pages.cms.webtree.update.meta.path}
          element={(<Update />)}
        />
        <Route
          path={Pages.cms.webtree.updatePath.meta.path}
          element={(<UpdatePath />)}
        />
      </Route>
    </Routes>
  );
}
